<template>
  <detail-layout-full-width>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="lg:mb-2">
              <div class="mandatory pt-2">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t('companies.configuration.pge_header') }}</h3>

                <base-collapsible-form ref="baseCollapsibleFace"
                  class="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
                  <template slot="headerRight">
                    <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">
                      {{ $t('companies.configuration.status_change_email') }}
                      <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2" style="display: inline;" />
                    </h3>
                  </template>
                  <template slot="content">
                    <!-- <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.configuration.status_change_email')}}</label> -->
                    <el-form-item prop="FaceMailInvoice">
                      <el-input :disabled="isRoleUserOrConsulta" clearable class="w-full" v-model="form.FaceMailInvoice"
                        :maxlength='maxLengthCorreos' />
                    </el-form-item>

                    <div class="mb-4">
                      <el-switch class="switch-text break-normal" v-model="form.FaceRecoverMail"
                        :active-text="$t('companies.configuration.facturae_recover_mail')"></el-switch>
                    </div>
                  </template>
                </base-collapsible-form>

                <base-collapsible-form ref="baseCollapsibleTuComunidad"
                  class="mt-2 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
                  <template slot="headerRight">
                    <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t('tipos.pge.tucomunidad') }}</h3>
                  </template>
                  <template slot="content">
                    <label
                      class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('users.entity_name') }}</label>
                    <el-form-item prop="TuComunidadUsuario">
                      <el-input :disabled="isRoleUserOrConsulta" clearable class="w-full"
                        v-model="form.TuComunidadUsuario" maxlength="50" />
                    </el-form-item>

                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('users.password') }}</label>
                      <el-form-item prop="TuComunidadPassword">
                        <el-input :disabled="isRoleUserOrConsulta" clearable show-password class="w-full"
                          v-model="form.TuComunidadPassword" autocomplete="new-password" maxlength='50' />
                      </el-form-item>
                      <!-- <el-popover
                      ref="popovertc"
                      placement="top-start"
                      :title="$t('validation.popup.title')"
                      width="320"
                      trigger="focus"
                      popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                      >
                      <div>
                        <div><base-icon-pass-validation :validated="validationtc.numChar"/>{{$t('validation.popup.num_char')}}</div>
                        <div><base-icon-pass-validation :validated="validationtc.numMin"/>{{$t('validation.popup.num_min')}}</div>
                        <div><base-icon-pass-validation :validated="validationtc.charMinus"/>{{$t('validation.popup.char_minus')}}</div>
                        <div><base-icon-pass-validation :validated="validationtc.charMayus"/>{{$t('validation.popup.char_mayus')}}</div>
                        <div><base-icon-pass-validation :validated="validation.especial"/>{{$t('validation.popup.especial')}}</div>
                      </div>
                    </el-popover> -->
                    </div>
                  </template>
                </base-collapsible-form>

                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t('companies.configuration.config_firma') }}</h3>
                <div class="mb-4">
                  <el-switch class="switch-text break-normal" v-model="form.FirmarFacturae"
                    :active-text="$t('companies.configuration.config_firma_facturae')"></el-switch>
                </div>
                <div class="mb-4">
                  <el-switch class="switch-text break-normal" v-model="form.FirmarAdjuntos"
                    :active-text="$t('companies.configuration.config_firma_adjuntos')"></el-switch>
                </div>

                <div class="rounded-md bg-secondary-50 p-1 dark:text-darkblue-400 dark:bg-darkblue-900 mt-8">
                  <div>
                    <div v-if="form.CN" class="flex space-between items-end m-2">
                      <div class="w-full">
                        <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold">{{ $t('certificates.entity_name') }}</h2>
                        <div class="px-2 w-full mt-2">
                          <base-ro-input :label="$t('app.name')" :data="form.CN" />
                        </div>
                      </div>
                      <base-button class="mb-1" mode="primary" :text="$t('app.detail')" @click.prevent.stop="goDetailCert"
                        :loading="isGeneralLoading" />
                    </div>
                    <div v-else class="flex space-between items-center m-2">
                      <div class="flex flex-col w-full">
                        <h2 class="font-bold mb-2">{{ $t('companies.configuration.no_associated_cert') }}</h2>
                        <base-ro-input label=""
                          :data="$t('companies.configuration.no_associated_cert_advice')" />
                      </div>
                      <base-button v-if="!isRoleUserOrConsulta" class="mb-1" mode="primary"
                        :text="$t('app.link_entity')" @click.prevent.stop="togglelinkCertificateDialog"
                        :loading="isGeneralLoading" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </template>
      </base-footer>
      <link-certificate-dialog :dialogOpen="linkCertificateDialog" @toggleDialog="togglelinkCertificateDialog"
        @applyDialog="applylinkCertificateDialog" :clientId="this.form.clienteId" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import LinkCertificateDialog from '@/components/LinkCertificateDialog.vue'

import { getCompany } from '@/services/companies/getCompany'
import { getConfigCompany } from '@/services/companies/getConfigCompany'
import { linkCertificate } from '@/services/certificates/linkCertificate'
import { updateConfigCompany } from '@/services/companies/updateConfigCompany'

// import moment from 'moment'
import { email as emailRegex } from '@/utils/regex'
import { i18n } from '@/i18n'


function isValidEmail (value) {
  // Un solo email
  return emailRegex.test(value)
  // Varios emails
  // return value.split(';').every(item => emailRegex.test(item))
}

export default {
  /* eslint-disable camelcase */
  name: 'config-detail',
  components: {
    DetailLayoutFullWidth,
    LinkCertificateDialog,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('configurations.header'),
        icon: 'companies',
        breadcrumb: {},
        url: 'companies/detail'
      },
      linkCertificateDialog: false,
      maxLengthCorreos: 500,
      form: {
        CN: null,
        clienteId: null,
        SerialNumber: null,
        TipoCertificado: null,

        FaceMailInvoice: '',
        FaceRecoverMail: false,
        TuComunidadUsuario: '',
        TuComunidadPassword: '',
        FirmarFacturae: false,
        FirmarAdjuntos: false,
      },
      validationgv: {
        general: false,
        numChar: false,
        numMin: false,
        charMinus: false,
        charMayus: false,
      },
      validationtc: {
        general: false,
        numChar: false,
        numMin: false,
        charMinus: false,
        charMayus: false,
      },
    }
  },
  computed: {
    id: function () {
      return parseInt(this.$route.params.id)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    rules () {
      return {
        FaceMailInvoice: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isEmailValid, trigger: 'blur' }
        ],
        TuComunidadUsuario: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.validateTuComunidadUser, trigger: 'blur' },
        ],
        TuComunidadPassword: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.validateTuComunidadPassword, trigger: 'blur' },
        ],
      }
    },
    extensionTooltipMessage: function () {
      var pges = ['FACe', 'Biscaytik', 'Vizcaya', 'Alava', 'Guipuzcua']
      return this.$t('tooltip.status_change_email_advice', { pges: this.listToCommaString(pges, true) })
    },
  },
  watch: {
    // form: {
    //   deep: true,
    //   immediate: true,
    //   handler: 'watchFormHandler'
    // }
  },
  created: async function () {
  },
  mounted: async function () {
    this.$refs.baseCollapsibleFace.toggle()
    // this.$refs.baseCollapsibleGobiernoVasco.toggle()
    // this.$refs.baseCollapsibleTuComunidad.toggle()

    const companyId = this.$route.params.id
    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })

    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: '', name: breadcrumbHeader })
    } else {
      const company = await this.downloadCompanyData(companyId)
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }
    const config = await this.downloadDataConfig(companyId)
    this.setConfig(config)

    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    togglelinkCertificateDialog () {
      this.linkCertificateDialog = !this.linkCertificateDialog
    },
    applylinkCertificateDialog: async function (certificate) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.togglelinkCertificateDialog()
      try {
        const idCIFEmpresa = parseInt(this.$route.params.id)
        const params = {
          idCIFS: [idCIFEmpresa],
          SerialNumber: certificate.SerialNumber,
          TipoCertificado: certificate.TipoCertificado,
          idCliente: certificate.idCliente
        }
        const response = await linkCertificate(params)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          const config = await this.downloadDataConfig(idCIFEmpresa)
          this.setConfig(config)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goDetailCert: function () {
      const idEmpresa = this.form.clienteId
      const serial = this.form.SerialNumber
      const tipo = this.form.TipoCertificado
      this.$router.push({ name: 'certificates/detail', params: { idCliente: idEmpresa, serial, tipoCertificado: tipo } })
    },
    isPasswordValidtc: function (rule, value, callback) {
      let re = /^\w+$/
      const reMin = /^\w+$/
      const reNumber = /[0-9]/
      const reMinus = /[a-z]/
      const reMayus = /[A-Z]/
      if (!value) {
        this.validationtc.general = false
        this.validationtc.numChar = false
        this.validationtc.numMin = false
        this.validationtc.charMinus = false
        this.validationtc.charMayus = false
        // return callback(new Error(i18n.t('validation.complete')))
        callback()
      } else {
        if (!re.test(value)) {
          this.validationtc.general = false
        } else {
          this.validationtc.general = true
        }
        if (value.length < 8) {
          this.validationtc.numChar = false
        } else {
          this.validationtc.numChar = true
        }
        re = /[0-9]/
        if (!re.test(value)) {
          this.validationtc.numMin = false
        } else {
          this.validationtc.numMin = true
        }
        re = /[a-z]/
        if (!re.test(value)) {
          this.validationtc.charMinus = false
        } else {
          this.validationtc.charMinus = true
        }
        re = /[A-Z]/
        if (!re.test(value)) {
          this.validationtc.charMayus = false
        } else {
          this.validationtc.charMayus = true
        }
        if (!reMin.test(value) || value.length < 8 || !reNumber.test(value) || !reMinus.test(value) || !reMayus.test(value)) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
      }
      callback()
    },
    isPasswordValidgv: function (rule, value, callback) {
      let re = /^\w+$/
      const reMin = /^\w+$/
      const reNumber = /[0-9]/
      const reMinus = /[a-z]/
      const reMayus = /[A-Z]/
      if (!value) {
        this.validationgv.general = false
        this.validationgv.numChar = false
        this.validationgv.numMin = false
        this.validationgv.charMinus = false
        this.validationgv.charMayus = false
        // return callback(new Error(i18n.t('validation.complete')))
        callback()
      } else {
        if (!re.test(value)) {
          this.validationgv.general = false
        } else {
          this.validationgv.general = true
        }
        if (value.length < 8) {
          this.validationgv.numChar = false
        } else {
          this.validationgv.numChar = true
        }
        re = /[0-9]/
        if (!re.test(value)) {
          this.validationgv.numMin = false
        } else {
          this.validationgv.numMin = true
        }
        re = /[a-z]/
        if (!re.test(value)) {
          this.validationgv.charMinus = false
        } else {
          this.validationgv.charMinus = true
        }
        re = /[A-Z]/
        if (!re.test(value)) {
          this.validationgv.charMayus = false
        } else {
          this.validationgv.charMayus = true
        }
        if (!reMin.test(value) || value.length < 8 || !reNumber.test(value) || !reMinus.test(value) || !reMayus.test(value)) {
          return callback(new Error(i18n.t('validation.pass.main')))
        }
      }
      callback()
    },
    validateTuComunidadUser: function (rule, value, callback) {
      if (!value && this.form.TuComunidadPassword) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    validateTuComunidadPassword: function (rule, value, callback) {
      if (!value && this.form.TuComunidadUsuario) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    validateGobiernoVascoUser: function (rule, value, callback) {
      if (!value && this.form.GobiernoVascoPassword) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else if (value.length > this.maxLengthCorreos) {
        callback(new Error(i18n.t('validation.email_length', { n_chars: i18n.tc('app.n_character', this.maxLengthCorreos) })))
      } else {
        callback()
      }
    },
    submitForm: async function (formName) {
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            idCIFEmpresa: this.id,
            FaceEmail: this.form.FaceMailInvoice,
            FaceRecuperarEmail: this.form.FaceRecoverMail,
            TuComunidadUsuario: this.form.TuComunidadUsuario,
            TuComunidadPassword: this.form.TuComunidadPassword,
            FirmarFacturae: this.form.FirmarFacturae,
            FirmarAdjuntosExternos: this.form.FirmarAdjuntos,
          }
          const response = await updateConfigCompany(payload)
          if (response && response.blnError === false) {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
          } else {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
      this.$store.commit('setIsLoading', false)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'companies' })
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: companyId }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(`${company.msgError} [${company.codError}]`)
        } else {
          return company.CIFEmpresa
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadDataConfig: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: companyId }
        const config = await getConfigCompany(params)
        if (config.blnError === true) {
          this.doFeedback(`${config.msgError} [${config.codError}]`)
        } else {
          return config.Configuracion
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setConfig: function (config) {
      if (config) {
        this.form.CN = config.CN ? config.CN : null
        this.form.clienteId = config.idCliente ? config.idCliente : null
        this.form.SerialNumber = config.SerialNumber ? config.SerialNumber : null
        this.form.TipoCertificado = config.TipoCertificado ? config.TipoCertificado : null

        this.form.FaceMailInvoice = config.FaceEmail ? config.FaceEmail : null
        this.form.FaceRecoverMail = config.FaceRecuperarEmail ? config.FaceRecuperarEmail : null
        this.form.TuComunidadUsuario = config.TuComunidadUsuario ? config.TuComunidadUsuario : null
        this.form.TuComunidadPassword = config.TuComunidadPassword ? config.TuComunidadPassword : null

        this.form.FirmarFacturae = config.FirmarFacturae ? config.FirmarFacturae : null
        this.form.FirmarAdjuntos = config.FirmarAdjuntosExternos ? config.FirmarAdjuntosExternos : null
      }
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic>img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
